//获取webapp资源
import { getLocale } from "src/gs-utils/core/storage/LocaleManager";
import { get } from "src/utils/request-manager";

export const getWebappRobotStatus = async () => {
  return get(`/static/webapp/robot_status_function/v1/robot_status.json?t=${+new Date}`)
};

export const getWebappDeviceLimits = async () => {
  return get(`/static/webapp/device_limits/${getLocale()}.json?t=${+new Date}`)
};
